import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class System_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="system_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>System Overview</h2>
              <p>
                In addition to customer defined objects Nexoid API includes
                system objects. System objects work the same as user defined
                objects just replace the “record” part of the URL with
                “settings”.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default System_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/System_overview.js